import { Shield } from 'lucide-react';
import { DonorWallPreview } from '@/components/donate/DonorWallPreview';
import { LiveDonorTicker } from '@/components/donate/LiveDonorTicker';
import { MonthlyWarriorSocialProof } from '@/components/donate/MonthlyWarriorSocialProof';

export function DonateTrustStrip(): JSX.Element {
  return (
    <aside className="lg:sticky lg:top-6 h-fit rounded-2xl border border-gray-200 bg-gradient-to-b from-blue-50 to-white p-5 space-y-4">
      <div>
        <p className="text-xs font-bold uppercase tracking-wide text-blue-700">Your gift in context</p>
        <p className="mt-2 text-sm text-gray-700 leading-relaxed">
          Every donation helps fund dialysis sessions, patient stories, and long-term kidney care programs for
          CKD warriors in the Philippines.
        </p>
      </div>
      <LiveDonorTicker />
      <MonthlyWarriorSocialProof />
      <DonorWallPreview />
      <div className="flex items-start gap-2 text-xs text-gray-600">
        <Shield size={16} className="mt-0.5 shrink-0 text-blue-600" aria-hidden />
        <p>Secure checkout with Stripe. Monthly gifts can be updated or canceled anytime from your donor dashboard.</p>
      </div>
    </aside>
  );
}
